import React, { useState } from 'react'
import { Panel, Row, Col, Message, Form, Input, InputGroup, Checkbox, CheckboxGroup } from 'rsuite'
import CustomIconMessageInfo from '../../widgets/CustomIconMessageInfo'
import { isRequired, isValidators } from '../../utils/ValidatorUtils'
import NumberFormat from 'react-number-format'
//import { startLoading, doneLoading } from '../../utils/loading'

const personstyles = {
  //width: 180,
  marginBottom: 10,
}
const detailstyles = {
  //width: 500,
  marginBottom: 10,
}

export default function TargetGroupAndAreaForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
}) {
  const [schema, setSchema] = useState(_schema)

  const updateSchemaValue = () => {
    setSchema((state) => ({
      ...state,
      schema,
    }))
  }

  const handleChange = (value) => {
    console.log(value)
    // let selectObj = value.map((item) => {
    //   return { id: item, numOfPeople: '', detail: '' }
    // })

    //schema.criteriaList.optionSelected = value
    setSchema((state) => ({
      ...state,
      targetGroup: {
        ...state.targetGroup,
        criteriaList: {
          ...state.targetGroup.criteriaList,
          optionSelected: value,
        },
      },
    }))
    setValue(schema.targetGroup.criteriaList.name, value)
    updateSchemaValue()
  }

  const inputDetailChange = (value, index) => {
    // console.log('value', value, 'index', index)
    schema.targetGroup.criteriaList.options[index].detail.value = value
    updateSchemaValue()
  }

  const inputNumOfPeopleChange = (value, index, paramName) => {
    console.log('value', value, 'index', index)
    schema.targetGroup.criteriaList.options[index].value
    schema.targetGroup.criteriaList.options[index].numberOfPeople.value = value

    setValue(paramName, value)
    clearErrors(paramName)
    updateSchemaValue()
  }

  const generateCheckbox = () => {
    return schema.targetGroup.criteriaList.options.map((item, index) => {
      const isDisabled = !schema.targetGroup.criteriaList.optionSelected.some(
        (e) => e === item.value
      )

      return (
        <>
          {errors[item.detail.name] && (
            <Message showIcon type="error" description={errors[item.detail.name].message} />
          )}
          {errors[item.numberOfPeople.name] && (
            <Message showIcon type="error" description={errors[item.numberOfPeople.name].message} />
          )}
          <Row>
            <Col xs={24} sm={24} md={8} lg={8}>
              <Checkbox value={item.value}>{item.text}</Checkbox>
            </Col>
            <Col xs={24} sm={24} md={6} lg={6}>
              <InputGroup style={personstyles} disabled={isDisabled}>
                <InputGroup.Addon>{item.numberOfPeople.preText}</InputGroup.Addon>
                <Controller
                  key={item.numberOfPeople.name}
                  name={item.numberOfPeople.name}
                  control={control}
                  rules={{
                    required: isDisabled
                      ? false
                      : 'กรุณากรอก ' + item.numberOfPeople.preText + item.numberOfPeople.postText,
                  }}
                  // value={item.numberOfPeople.value}
                  defaultValue={item.numberOfPeople.value}
                  render={(props) => {
                    return (
                      // <InputNumber
                      //   value={item.numberOfPeople.value}
                      //   onChange={(e) => inputNumOfPeopleChange(e, index, item.numberOfPeople.name)}
                      // />
                      <NumberFormat
                        className="rs-input"
                        thousandSeparator={true}
                        value={item.numberOfPeople.value}
                        onValueChange={(value) => {
                          inputNumOfPeopleChange(value.floatValue, index, item.numberOfPeople.name)
                        }}
                      />
                    )
                  }}
                />
                <InputGroup.Addon>{item.numberOfPeople.postText}</InputGroup.Addon>
              </InputGroup>
            </Col>
            <Col xs={24} sm={24} md={10} lg={10}>
              <InputGroup style={detailstyles} disabled={isDisabled}>
                <InputGroup.Addon>{item.detail.text}</InputGroup.Addon>
                <Input
                  name={item.detail.name}
                  value={item.detail.value}
                  inputRef={register}
                  onChange={(e) => inputDetailChange(e, index)}
                />
              </InputGroup>
            </Col>
          </Row>
        </>
      )
    })
  }

  return (
    <div>
      <Form>
        <Panel accordion bodyFill>
          <Panel header="" defaultExpanded>
            {/* <Message
              showIcon
              type="warning"
              description={schema.targetGroup.targetCriteria.alert}
            />
            <br /> */}
            <label
              className={isRequired(schema.targetGroup.targetCriteria.validators) ? 'required' : ''}
            >
              {schema.targetGroup.targetCriteria.label}
            </label>
            {errors.targetCriteria && (
              // <Message showIcon type="error" description={errors.projectFeature.message} />
              <Message showIcon type="error" description={errors.targetCriteria.message} />
            )}
            <Input
              componentClass="textarea"
              rows={3}
              maxLength="1000"
              name={schema.targetGroup.targetCriteria.name}
              inputRef={register(isValidators(schema.targetGroup.targetCriteria.validators))}
              defaultValue={schema.targetGroup.targetCriteria.value || 'ไม่ระบุ'}
              placeholder={schema.targetGroup.targetCriteria.hint}
              onChange={(e) => {
                schema.targetGroup.targetCriteria.value = e
                updateSchemaValue()
              }}
              disabled={true}
            />
          </Panel>

          <Panel defaultExpanded>
            <CustomIconMessageInfo content={schema.targetGroup.criteriaList.alert} />
            <br />
            <Controller
              key={schema.targetGroup.criteriaList.name}
              name={schema.targetGroup.criteriaList.name}
              control={control}
              rules={isValidators(schema.targetGroup.criteriaList.validators)}
              // value={item.numberOfPeople.value}
              defaultValue={schema.targetGroup.criteriaList.optionSelected}
              render={(props) => {
                return (
                  <CheckboxGroup
                    name={schema.targetGroup.criteriaList.name}
                    value={schema.targetGroup.criteriaList.optionSelected}
                    onChange={handleChange}
                  >
                    {generateCheckbox()}
                  </CheckboxGroup>
                )
              }}
            />
          </Panel>
        </Panel>
      </Form>
    </div>
  )
}
